export default __webpack_public_path__ + "static/media/cert-cpttm.9be673b4.jpg";